import * as ReactQuery from 'react-query';
import { getReferralActivityAPI } from './api';

export const GET_REFERRAL_ACTIVITY_KEY = '@referrals/get-referral-activity';

type UseGetReferralActivityOptions = {
  enabled?: boolean;
  isExternalReferral?: boolean;
};

export function useGetReferralActivity(
  id = '',
  {
    enabled = true,
    isExternalReferral = false,
  }: UseGetReferralActivityOptions = {}
) {
  const { data, isLoading, isError, refetch } = ReactQuery.useQuery(
    [GET_REFERRAL_ACTIVITY_KEY, id, isExternalReferral],
    () => getReferralActivityAPI(id, isExternalReferral),
    { enabled: enabled && Boolean(id) }
  );

  return {
    activity: data,
    isLoading,
    isError,
    refetch,
  };
}
